import { render, staticRenderFns } from "./bnvfile_progress.vue?vue&type=template&id=6c3344f8&"
import script from "./bnvfile_progress.vue?vue&type=script&lang=js&"
export * from "./bnvfile_progress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports